<template>
	<div style="margin-bottom: 6px;">
		<el-row>
			<el-col :span="24">
				<div style="margin: 0px 10px;">
					<vxe-form size="small" title-width="80" title-align="center">
						<vxe-form-item title="月份" field="month" :item-render="{}">
							<template #default>
								<datePicker :value="currentMonth" type="month" @change="change" />
							</template>
						</vxe-form-item>
					</vxe-form>
				</div>
			</el-col>
		</el-row>
		<el-row :gutter="20">
			<el-col :span="8">
				<div>
					<el-statistic group-separator="," :precision="0" :value="count" title="推荐人数/月"></el-statistic>
				</div>
			</el-col>
			<el-col :span="8">
				<div>
					<el-statistic group-separator="," :precision="0" :value="dealcount" title="成单人数/月"></el-statistic>
				</div>
			</el-col>
			<el-col :span="8">
				<div>
					<el-statistic group-separator="," :precision="4" :value="amount" title="成单金额/月"></el-statistic>
				</div>
			</el-col>
		</el-row>
	</div>
</template>
<style>

</style>

<script>
	import datePicker from '@_system/components/formcomponents/common/datePicker/index.vue'
	export default {
		name: '',
		props: {
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				like: true,
				count: 0,
				dealcount: 0,
				amount: 0,
			}
		},
		watch: {

		},
		mounted() {
			this.static()
		},
		computed: {
			currentMonth(){
				let currentDate = new Date()
				currentDate.setDate(1)
				return currentDate.getTime()
			}
		},

		methods: {
			static(date=null) {
				this.$api.recommend.static({date:date}).then((res) => {
					this.count = res.count
					this.dealcount = res.dealcount
					this.amount = res.amount
				})
			},
			change(e){
				this.static(e)
				
			}
		},
		components: {
			datePicker
		}
	}
</script>
